<template lang="html">
  <div>

    

    <div v-if="shop.variants_on !== '0'">

      <label class="form__label">Option</label>
      <select style="margin-bottom:10px" class="selectAddToBasket" name="qty" v-model="variant">
            <option type="text" :disabled="shop.track_qty && variant.qty <= 0" v-for="variant in shop.variants" name="" :value="variant">
              {{variant.option}} - {{symbol}}{{variant.price}}
              
              {{(shop.track_qty && variant.qty <= 0) ? '**SOLD OUT**' : ''}}
            </option>
      </select>

      <label class="form__label">Quantity</label>
        <select class="selectAddToBasket" name="qty" v-model="qty">
              <option type="text" name="" value="1">1</option>
              <option type="text" name="" value="2">2</option>
              <option type="text" name="" value="3">3</option>
              <option type="text" name="" value="4">4</option>
              <option type="text" name="" value="5">5</option>
              <option type="text" name="" value="6">6</option>
              <option type="text" name="" value="7">7</option>
              <option type="text" name="" value="8">8</option>
              <option type="text" name="" value="9">9</option>
              <option type="text" name="" value="10">10</option>
        </select>
        <button v-if="variant" @click.prevent="addToBasket" :disabled="added"  type="button" name="button" class="btn  btn--quaternary  btn--full  mt20">{{addText}}</button>

    </div>
    

    <div v-else>

          <div v-if="shop.track_qty && shop.qty > 0">

          <label class="form__label">Quantity</label>
            <select class="selectAddToBasket" name="qty" v-model="qty">
                  <option type="text" name="" value="1">1</option>
                  <option type="text" name="" value="2">2</option>
                  <option type="text" name="" value="3">3</option>
                  <option type="text" name="" value="4">4</option>
                  <option type="text" name="" value="5">5</option>
                  <option type="text" name="" value="6">6</option>
                  <option type="text" name="" value="7">7</option>
                  <option type="text" name="" value="8">8</option>
                  <option type="text" name="" value="9">9</option>
                  <option type="text" name="" value="10">10</option>
            </select>
            <button @click.prevent="addToBasket" :disabled="added"  type="button" name="button" class="btn  btn--quaternary  btn--full  mt20">{{addText}}</button>

        </div>
        
        <div class="soldOut" v-else>
            SOLD OUT
        </div>

    </div>


      
  </div>

</template>

<script>
export default {
  name:'add-to-basket',
  props: {
    shop: {
      type:Object,
      required:true
    },
    symbol: {
      type:String,
      required:true
    },
  },
  data(){
    return {
      qty: 1,
      variant: false,
      added: false,
      addText: 'Add to basket'
    }
  },
  methods:{
    addToBasket(){
      this.addText = '👍 ' + this.__('Added to basket');
      this.added = true;

      setTimeout(()=>{
          this.addText = this.__('Add to basket');
      },3000)

      var basketCount = document.getElementById('basketCount');
      basketCount.innerText = Number(basketCount.innerText)+1;

      axios.post('/basket/add',{
        product: this.shop,
        qty: this.qty,
        seats: false,
        tickets: false,
        variant: this.variant,
        url: window.location.href,
      }).then((response)=>{
        this.added = false;
      });

      //this.$root.$emit('addMerchandiseToBasket',[this.shop,this.qty,this.variant]);
    }
  }
}
</script>

<style lang="css">
.selectAddToBasket{
  border: 1px solid silver;
    border-radius: 6px;
    padding: 10px;
    width: 100%;
}
.soldOut{
  background:red;
			color:white;
			padding: 6px 10px 4px 10px;
			display:inline-block;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/AddToBasket.vue